// extracted by mini-css-extract-plugin
export default {"container":"OTDataTable_container__lW2fu","heading":"OTDataTable_heading__zSKl2","headingText":"OTDataTable_headingText__-nYcE"};